import { Navigate, useNavigate, useParams } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { DEPARTMENTS, visibleModules } from "@/lib/departments";

export default function Department() {
  const { deptKey } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const dept = DEPARTMENTS.find((d) => d.key === deptKey);
  if (!dept) return <Navigate to="/" replace />;
  const modules = visibleModules(dept, user.role);
  if (modules.length === 0) return <Navigate to="/" replace />;

  return (
    <div data-testid={`department-${dept.key}`}>
      <h1 className="font-heading text-2xl font-extrabold tracking-tight sm:text-3xl">{dept.label}</h1>
      <p className="mt-1 text-sm text-muted-foreground">Choose a module to continue.</p>
      <div className="mt-5 grid gap-3 sm:grid-cols-2">
        {modules.map((m) => {
          const Icon = m.icon;
          return (
            <button
              key={m.to}
              data-testid={`dept-card-${m.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => navigate(m.to)}
              className="group flex items-center gap-3 rounded-md border bg-card p-4 text-left transition-transform hover:-translate-y-[1px] hover:border-primary/40 active:scale-[0.99]"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent text-accent-foreground">
                <Icon className="h-5 w-5" />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate font-heading text-base font-extrabold">{m.label}</span>
                <span className="block truncate text-xs text-muted-foreground">{m.desc}</span>
              </span>
              <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground transition-transform group-hover:translate-x-0.5" />
            </button>
          );
        })}
      </div>
    </div>
  );
}
